/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import Checkbox from '@mui/joy/Checkbox';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import Stack from '@mui/joy/Stack';
import { v4 as uuidv4 } from 'uuid';

interface Props {
  formStyleLabel?: string;
  tooltip?: string;
  mdCol?: string;
  label?: any;
  name: string;
  values: any;
  onChange?: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  className?: string;
  id?: string;
  logo?: string;
  setValue?: (val: boolean) => void;
  isMissing?: boolean;
  setLabelHight?: boolean;
}

const CheckboxInput = (props: Props) => {
  const [checked, setChecked] = React.useState<boolean>(false);
  React.useEffect(() => {
    if (Array.isArray(props.values) && props.setValue) {
      props.values.includes('on') ? props.setValue(true) : props.setValue(false);
    } else if (Array.isArray(props.values)) {
      props.values.includes('on') ? setChecked(true) : setChecked(false);
    } else if (props.values === true) {
      setChecked(true);
    } else {
      setChecked(false);
    }
    if (Array.isArray(props.values) && props.setValue) {
      props.values.includes('on') ? props.setValue(true) : props.setValue(false);
    }
  }, [props.values]);

  return (
    <div
      className={props.className}
      style={{
        gap: '16px',
        // padding: '16px',
        border: props.isMissing ? '1px solid #DC2626' : 'none',
        borderRadius: '8px',
        backgroundColor: props.isMissing ? '#FEF2F2' : 'transparent',
      }}
    >
      {props.formStyleLabel && (
        <FormLabel
          className={`label-14px pb-1 ${props.logo ?? ''}`.trim()}
          sx={{
            backgroundColor: props.isMissing ? '#FFEBEB' : '',
            fontSize: '14px',
            mb: 1,
            display: 'block',
            fontWeight: 500,
            color: '#374151',
          }}
        >
          {props.formStyleLabel}
        </FormLabel>
      )}
      <Stack direction="row" alignItems="center" sx={{ paddingLeft: '4px', marginTop: '1px' }}>
        <Checkbox
          id={`${props?.id ?? props.name + '_' + uuidv4()}`}
          disabled={props.disabled}
          checked={checked ?? false}
          name={props.name}
          onChange={props.onChange}
          readOnly={props.readOnly}
          label={
            !props?.setLabelHight ? (
              <span className={`${props.logo}`}>
                <div
                  style={{
                    display: 'inline-block',
                    backgroundColor: props.isMissing ? '#FFEBEB' : '',
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#374151',
                  }}
                >
                  {props.label}
                </div>
              </span>
            ) : (
              <div
                style={{
                  display: 'inline-block',
                  backgroundColor: props.isMissing ? '#FFEBEB' : '',
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#374151',
                }}
                className='fs-base'
              >
                {props.label?.trim?.() ?? props.label}
                <span className={`${props.logo}`}></span>
              </div>
            )
          }
          size="md"
          color={props.isMissing ? 'danger' : 'primary'}
          variant="outlined"
          sx={{
            width: '100%',
            maxWidth: '100%',
            minWidth: 0,
            alignItems: 'flex-start',
            '--Checkbox-gap': '8px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
          }}
        />
      </Stack>
      {props.isMissing && (
        <FormHelperText sx={{ color: '#DC2626', fontSize: '12px' }}>
          This field is required.
        </FormHelperText>
      )}
      {props.feedback}
    </div>
  );
};

export default CheckboxInput;
